import { EntryLayout } from '@/layouts'
// import Index from '@/views/Index'

const RouteView = {
  name: 'RouteView',
  render: (h) => h('router-view')
}

export const constantRouterMap = [
  {
    path: '/',
    redirect: '/login'
  },
  // {
  //   path: '/',
  //   name: 'Index',
  //   component: Index
  // },
  {
    path: '/entry/:serviceId',
    redirect: '/entry/:serviceId/ERP',
    component: EntryLayout,
    children: [
      {
        path: ':systemCode',
        component: RouteView,
        children: [
          {
           path: '',
            name: 'Welcome',
            component: () => import('@/views/Welcome'),
            meta: { routerView: true }
          },
          {
            path: 'iframe',
            name: 'Iframe',
            meta: { name: 'iframe', routerView: false }
          },
          {
            path: '404',
            name: 'Entry404',
            component: () => import('@/views/404'),
            meta: { routerView: true }
          },
          {
            path: '401',
            name: 'Entry401',
            component: () => import('@/views/401'),
            meta: { routerView: true }
          },
          {
            path: '402',
            name: 'Entry402',
            component: () => import('@/views/402'),
            meta: { routerView: true }
          },
          {
            path: ':name',
            meta: { routerView: false }
          }
        ]
      }
    ]
  },
  {
    path: '/login',
    name: 'UserLogin',
    component: () => import('@/views/login/Login')
  },
  {
    path: '/oauth/center',
    name: 'OauthCenter',
    component: () => import('@/views/Oauth/index.vue')
  },
  {
    path: '/oauth/login',
    name: 'OauthLogin',
    component: () => import('@/views/login/Login')
  },
  {
    path: '/check-token',
    name: 'CheckToken',
    component: () => import('@/views/CheckToken')
  },
  {
    path: '/401/:systemCode?',
    name: '401',
    component: () => import('@/views/401')
  },
  {
    path: '/500',
    component: () => import('@/views/500')
  },
  {
    path: '/transfer',
    name: 'Transfer',
    component: () => import('@/views/Transfer'),
    meta: { name: 'transfer' }
  }
  // {
  //   path: '*',
  //   component: () => import('@/views/404')
  // }
]

export const asyncRouterMap = []
